import styles from "./data-large-block.module.scss";

const DataLargeBlock = ({children}) => {
    return (
        <div className={styles.wrapper}>
            {children}
        </div>
    )
}

export default DataLargeBlock;